var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "topBar" }, [
        _c("div", { staticClass: "in" }, [
          _c("div", { staticClass: "menu-top-bar-container" }, [
            _c("ul", { staticClass: "menu", attrs: { id: "menu-top-bar" } }, [
              _c(
                "li",
                {
                  staticClass:
                    "menu-item menu-item-type-post_type menu-item-object-page menu-item-621",
                  attrs: { id: "menu-item-621" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "https://themailingexpert.com/about-us/" }
                    },
                    [_vm._v("About Us")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "menu-item menu-item-type-post_type menu-item-object-page menu-item-568",
                  attrs: { id: "menu-item-568" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/why-compare-the-mailkit/"
                      }
                    },
                    [_vm._v("Why The Mailing Expert")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "menu-item menu-item-type-post_type menu-item-object-page menu-item-515",
                  attrs: { id: "menu-item-515" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://themailingexpert.com/contact-us/"
                      }
                    },
                    [_vm._v("Contact Us")]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "in" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "logo" }, [
              _c("a", { attrs: { href: "https://themailingexpert.com/" } }, [
                _c("img", {
                  attrs: {
                    src:
                      "http://quote.themailingexpert.com/static/styles/mailkit/img/logo2.png",
                    alt: "The Mailing Expert"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header__ham" }, [
              _c("div", { attrs: { id: "nav-toggle" } }, [_c("span")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header__nav" }, [
            _c("div", { staticClass: "menu-main-navigation-container" }, [
              _c(
                "ul",
                { staticClass: "menu", attrs: { id: "menu-main-navigation" } },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-205"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Mail "),
                        _c("br"),
                        _vm._v(" & Franking"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-428"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://quote.themailingexpert.com/quotes-create"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-372"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://quote.themailingexpert.com/quotes-retrieve/"
                                  }
                                },
                                [_vm._v("Retrieve Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-774"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/let-us-do-it-for-you/"
                                  }
                                },
                                [_vm._v("Let Us Do It For You")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-427"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#mailandfranking"
                                  }
                                },
                                [_vm._v("Mail & Franking Useful Info")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-569"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/product-support/"
                                  }
                                },
                                [_vm._v("Product Support")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-519 current_page_item",
                              attrs: { "data-desc": 'id="menu-item-570"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/product-specification/"
                                  }
                                },
                                [_vm._v("Product Specification")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-374"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-857"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("XRay"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-575"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-xray/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-866"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#xray"
                                  }
                                },
                                [_vm._v("X Ray Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-574"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "break menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-698"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Letter "),
                        _c("br"),
                        _vm._v(" Openers"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-579"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-letter-openers/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-865"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#letteropeners"
                                  }
                                },
                                [_vm._v("Letter Openers Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-576"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-858"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Inserting "),
                        _c("br"),
                        _vm._v(" Machines"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-595"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-inserting-machines/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-867"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#insertingmachines"
                                  }
                                },
                                [_vm._v("Inserting Machines Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-580"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-859"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("MFD "),
                        _c("br"),
                        _vm._v(" Print Devices"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-594"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-mfd-print-devices/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-868"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#mfdandprint"
                                  }
                                },
                                [_vm._v("Print Devices Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-583"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      staticStyle: { position: "relative" },
                      attrs: { "data-desc": 'id="menu-item-860"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Hybrid "),
                        _c("br"),
                        _vm._v(" Mail Solutions"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-593"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-hybrid-mail/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              staticStyle: { position: "relative" },
                              attrs: { "data-desc": 'id="menu-item-869"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#hybridmail"
                                  }
                                },
                                [_vm._v("Hybrid Mail Solutions Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-586"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children mega-menu-columns-2",
                      attrs: { "data-desc": 'id="menu-item-861"' }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Scanning "),
                        _c("br"),
                        _vm._v(" Solutions"),
                        _c("span", { staticClass: "arrowDown" })
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("ul", { staticClass: "sub-menu" }, [
                          _c(
                            "li",
                            {
                              staticClass:
                                "titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-592"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/products-services-digitisation-and-scanning-2/"
                                  }
                                },
                                [_vm._v("New Quote")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "break titleElem menu-item menu-item-type-custom menu-item-object-custom",
                              attrs: { "data-desc": 'id="menu-item-870"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/helpdesk/#digitisationandscan"
                                  }
                                },
                                [_vm._v("Scanning Solutions Useful Info")]
                              )
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass:
                                "menu-item menu-item-type-post_type menu-item-object-page",
                              attrs: { "data-desc": 'id="menu-item-589"' }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/contact-us/"
                                  }
                                },
                                [_vm._v("Contact Us")]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01221927", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01221927","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/Header.vue
// module id = null
// module chunks = 